// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__Dm+fJ","outer":"modal_outer__9s9yV","close_icon_outer":"modal_close_icon_outer__JygE4","modal_body_outer":"modal_modal_body_outer__defc6"};